export default "__VITE_ASSET__Dljfnfc8__"